<template>
  <CrudFilter :has-filters="hasFilters" :loading-search="loadingBTN" :loading-clear="loadingTrashButton" @search="search" @clear="clearFields">
    <v-list-item>
      <v-text-field
        color="#086318"
        label="Nome do Usuário"
        class="rounded-lg"
        hide-details
        outlined
        dense
        v-model="userSearch.name"
      />
    </v-list-item>
    <v-list-item>
      <v-text-field
        color="#086318"
        label="E-mail"
        placeholder="Ex: joao.silva@example.com"
        class="rounded-lg"
        hide-details
        outlined
        dense
        v-model="userSearch.email"
      />
    </v-list-item>
    <v-list-item>
      <v-text-field
        color="#086318"
        label="CPF"
        outlined
        class="rounded-lg"
        v-model="userSearch.cpf"
        maxlength="14"
        hide-details
        v-mask="'###########'"
        dense
      />
    </v-list-item>
    <v-list-item>
      <v-autocomplete
        :items="hospitals"
        label="Unidade Hospitalar"
        class="rounded-lg"
        hide-details
        color="#086318"
        v-model="userSearch.hospital"
        item-value="hospital"
        item-text="hospital"
        dense
        outlined
      />
    </v-list-item>
    <v-list-item>
      <v-autocomplete
        :items="profiles"
        label="Perfil"
        class="rounded-lg"
        hide-details
        color="#086318"
        v-model="userSearch.profile"
        item-value="slug"
        item-text="name"
        dense
        outlined
      />
    </v-list-item>
  </CrudFilter>
</template>

<script>
import CrudFilter from "../widgets/Filter.vue";
import FormFieldsService from '@/service/FormFieldsService';
import Formatters from "@/utils/Formatters";
import { getUsers } from "@/service/basic-registrations/UserService";

export default {
  components: { CrudFilter },

  data() {
    return {
      loadingBTN: false,
      loadingTrashButton: false,
      userSearch: {},
      hospitals: [],
      profiles: [],
      options: {
        page: 0,
        itemsPerPage: 10,
        sortBy: ["name"],
        sortDesc: [false],
      },
    };
  },

  computed: {
    hasFilters() {
      return Object.values(this.userSearch || {}).some(v => v != null && v !== '');
    },
  },

  async mounted() {
    this.hospitals = await FormFieldsService.getUnities();
    this.profiles = await FormFieldsService.getProfiles();

    const savedSearch = sessionStorage.getItem('userSearchFilter');
    if (savedSearch) {
      this.userSearch = JSON.parse(savedSearch);
      this.search();
    }
  },

  methods: {
    async search() {
      this.loadingBTN = true;
      const { page, itemsPerPage } = this.options;

      sessionStorage.setItem('userSearchFilter', JSON.stringify(this.userSearch));

      const result = await getUsers({
        name: this.userSearch.name,
        hospital: this.userSearch.hospital,
        email: this.userSearch.email,
        profile: this.userSearch.profile,
        cpf: Formatters.removeNonNumeric(this.userSearch.cpf),
        page,
        per_page: itemsPerPage,
      });

      this.$emit('resource', result.data);
      this.loadingBTN = false;
    },

    clearFields() {
      this.loadingTrashButton = true;
      this.userSearch = {};
      sessionStorage.removeItem('userSearchFilter');
      setTimeout(() => {
        this.loadingTrashButton = false;
        this.search();
      }, 1000);
    },
  },
};
</script>
